export const displayGetBackToRecentTorchAddressSelector = ({displayGetBackToRecentTorchAddress}) => displayGetBackToRecentTorchAddress